import { cn } from "@/lib/cn";

/** Static border + a single subtle shimmer per DESIGN.md §7. Geometry must match the final element. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn("animate-shimmer rounded-sm border border-border bg-surface-2", className)} aria-hidden="true" />;
}
